define(['toolkit/b-controls-group/b-controls-group'], (BControlsGroup) => {
    return BControlsGroup.extend('notify', {
        service: false,

        events: {
            'click [data-name="close"]': '_onClose',
        },

        _onClose() {
            this.emit('close');
        },
    });
});
